/**
 * Created by stonewang on 2017/8/15.
 */
import config from './config';

const APIS = {
	/* mxm 登录 */
	login: `${config.mxm}/api/login`,
	/* 上传 */
	upload: `${config.server}/api/v1/dms/commonAttachUpload/mongoUpload`
};
export default APIS


// WEBPACK FOOTER //
// ./src/utils/services.js